import { Component } from '@theme/component';

/**
 * @typedef {{
 *   counter?: HTMLElement,
 *   loadMore?: HTMLButtonElement,
 * }} Refs
 */

/**
 * Best-selling bundles grid. The section renders every bundle block but keeps
 * only the first N visible via the `is-collapsed` class (handled in CSS). The
 * "View more" link reveals the rest client-side and updates the counter.
 *
 * @extends {Component<Refs>}
 */
class BestSellingComponent extends Component {
    connectedCallback() {
        super.connectedCallback();
        if (Shopify.designMode) this.#revealAll();
    }

    updatedCallback() {
        if (Shopify.designMode) this.#revealAll();
    }

    viewMore() {
        if (this.classList.contains('is-collapsed')) {
            this.#revealAll();
            return;
        }

        this.#collapse();
    }

    #revealAll() {
        this.classList.remove('is-collapsed');

        const { total } = this.dataset;
        const template = this.refs.counter?.dataset.countText;
        if (this.refs.counter && total && template) {
            this.refs.counter.textContent = template.replace('[count]', total).replace('[total]', total);
        }

        const lessLabel = this.refs.loadMore?.dataset.viewLess;
        if (this.refs.loadMore && lessLabel) this.refs.loadMore.textContent = lessLabel;
    }

    #collapse() {
        this.classList.add('is-collapsed');

        const { initial, total } = this.dataset;
        const template = this.refs.counter?.dataset.countText;
        if (this.refs.counter && initial && total && template) {
            this.refs.counter.textContent = template.replace('[count]', initial).replace('[total]', total);
        }

        const moreLabel = this.refs.loadMore?.dataset.viewMore;
        if (this.refs.loadMore && moreLabel) this.refs.loadMore.textContent = moreLabel;
    }
}

if (!customElements.get('best-selling-component')) {
    customElements.define('best-selling-component', BestSellingComponent);
}
